import {
  Input,
  Directive
} from '@angular/core';

import {
  FormControl,
  FormGroup
} from '@angular/forms';

@Directive()
export abstract class BaseFieldRenderer {

  @Input() context: any;

  get field() {
    return this.context.field;
  }

  get form(): FormGroup {
    return this.context.form;
  }

  get row(): FormGroup | undefined {
    return this.context.row;
  }

  get control(): FormControl {

    // LINE ITEM ROW
    if (
      this.row &&
      typeof (this.row as any).get === 'function'
    ) {

      return this.row.get(
        this.field.name
      ) as FormControl;
    }

    // HEADER FIELD
    return this.form.get(
      this.field.name
    ) as FormControl;
  }

  get isDisabled(): boolean {
    return !!this.control?.disabled;
  }

  get isInvalid(): boolean {

    return !!(
      this.control?.invalid &&
      this.control?.touched
    );
  }

  getError(): string {

    if (!this.control?.errors)
      return '';

    const errors = this.control.errors;

    if (errors['required'])
      return 'Required';

    if (errors['min'])
      return `Minimum value invalid`;

    if (errors['max'])
      return `Maximum value invalid`;

    if (errors['pattern'])
      return `Invalid format`;

    if (errors['softMax']) {

      const e = errors['softMax'];

      if (typeof e === 'object') {
        return `${e.field} cannot exceed ${e.max}`;
      }

      return 'Exceeded allowed limit';
    }

    return 'Invalid';
  }
}